export default {
  DELETE_FILE_SUCCESS: 'Content has been successfully deleted.',
  ADD_CONTENT: 'Add content to share',
  ADD_CONTENT_INFO: 'Upload your documents, links, images, or other materials here to share them with your visitors.',
  NO_CONTENT: 'You dont have any files or links added yet!',
  UPLOAD_FILES: 'Upload files',
  ADD_URL: 'Add URL',
  ADDED_CONTENT: 'Added files and URLs',
  URL: 'Url',
  ADD_URL_SUCCESS: 'URL generated and saved successfully!',
  DISPLAY_NAME: 'Display name',
  BROCHURE: 'Brochure',
  CHOOSE_FILE: 'Choose file',
  DRAG_DROP: 'Drag and drop',
  TO_UPLOAD: 'to upload',
  MAX_FILE_SIZE: 'Max 3mb size is allowed',
  MAX_LEN_ERR: 'File name length too long',
  MAX_SIZE_ERR: 'File size limit exceeds',
  FILES_UPLOAD_SUCCESS: 'Files uploaded successfully'
}
